import * as requestFromServer from './notificationsCrud';
import { notificationsSlice, callTypes } from './notificationsSlice';
import { RequestCancellationManager } from '../../_common/utils/RequestCancellationManager';
import { v4 as guid } from 'uuid';

export const geNotificationsListIDPrefix = 'getNotificationsList';
const { actions } = notificationsSlice;

interface Notification {
  id: string;
  title?: string;
  message?: string;
}

interface NotificationsResponse {
  errorCode: number;
  data: {
    totalNotificationsCount: number;
    notifications: Notification[];
    pageCount: number;
  };
}

interface QueryParams {
  pageNumber?: number;
  pageSize?: number;
}

type Dispatch = (action: any) => void;

const getNotificationsList =
  (storeMethod: any) =>
    (queryParams: QueryParams) =>
      (dispatch: Dispatch) => {
        dispatch(actions.startCall({ callType: callTypes.list }));

        const requestID = `${geNotificationsListIDPrefix}-${guid()}`;
        const cancellationHandlers =
          RequestCancellationManager.createCancellationHandlers(requestID);

        return requestFromServer
          .getNotifications(queryParams, cancellationHandlers)
          .then((response: { data: NotificationsResponse }) => {
            const {
              errorCode,
              data: { totalNotificationsCount, notifications, pageCount },
            } = response.data;

            if (errorCode !== 0) throw new Error();

            dispatch(
              storeMethod({
                totalCount: totalNotificationsCount || 0,
                pageCount: pageCount || 0,
                entities: notifications || [],
              })
            );
          })
          .catch((error: any) => {
            error.clientMessage = "Can't find users actions";
            dispatch(actions.catchError({ error, callType: callTypes.list }));
          })
          .finally(() => {
            RequestCancellationManager.forgetRequest(requestID);
          });
      };

export const getNotifications = getNotificationsList(actions.notificationsFetched);

export const getNextNotifications = getNotificationsList(actions.notificationsAppended);

export const getNotificationsForExcelFile = (queryParams: QueryParams) => (dispatch: Dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
      .getNotificationsForExcelFile(queryParams)
      .then((response: any) => {
        const { errorCode, data } = response.data;

        if (errorCode !== 0) throw new Error();

        return data?.notifications ? data.notifications : [];
      })
      .catch((error: any) => {
        console.error({ error });
        error.clientMessage = "Can't get data!";
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  };